/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type CustomPopulationActionDtoAction =
  (typeof CustomPopulationActionDtoAction)[keyof typeof CustomPopulationActionDtoAction];

export const CustomPopulationActionDtoAction = {
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE',
} as const;
